/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apple_StoreInputs */

const en_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const ar_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متجر التطبيقات`)
};

const de_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App-Store`)
};

const es_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const fr_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const it_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const ja_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const ko_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앱스토어`)
};

const pt_br_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const ru_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const th_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แอปสโตร์`)
};

const tr_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const zh_cn_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

const zh_tw_apple_store = /** @type {(inputs: Apple_StoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App Store`)
};

/**
* | output |
* | --- |
* | "App Store" |
*
* @param {Apple_StoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const apple_store = /** @type {((inputs?: Apple_StoreInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apple_StoreInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_apple_store(inputs)
	if (locale === "ar") return ar_apple_store(inputs)
	if (locale === "de") return de_apple_store(inputs)
	if (locale === "es") return es_apple_store(inputs)
	if (locale === "fr") return fr_apple_store(inputs)
	if (locale === "it") return it_apple_store(inputs)
	if (locale === "ja") return ja_apple_store(inputs)
	if (locale === "ko") return ko_apple_store(inputs)
	if (locale === "pt_br") return pt_br_apple_store(inputs)
	if (locale === "ru") return ru_apple_store(inputs)
	if (locale === "th") return th_apple_store(inputs)
	if (locale === "tr") return tr_apple_store(inputs)
	if (locale === "zh_cn") return zh_cn_apple_store(inputs)
	return zh_tw_apple_store(inputs)
});